/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Payor({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/DueAmounts/Content/DueNow/Content/Payor"
  
}) {
let payorValueData = fromData.useDataFormat({ viewPath,
context: 'payor',
format: fromHelpers.getPayorName,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let payorAmountValueData = fromData.useDataFormat({ viewPath,
context: 'payor',
path: 'amount',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="Payor.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payor"
 format="helpers.js getPayorName"
 text={payorValueData}
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payor.amount"
 format="/Data/format.js numberMoney"
 text={payorAmountValueData}
/>
</div>
{children}
</React.Fragment>)
}